async function deleteMethods ({ record, vm, className }) {
  await vm.confirm('警告', '你确定要删除这条记录吗?')
  // 刪除此条用户数据 此用户id record.objectId
  let rs = await vm.$tkParse.put(`/classes/${className}/${record.objectId}`, { isDeleted: true }).catch(() => {
    vm.$notification['error']({
      message: '网络错误',
      description: '删除数据失败'
    })
  })
  if (rs) {
    vm.$notification['success']({
      message: '操作成功',
      description: '记录已被删除'
    })
    vm.refresh()
  }
}
async function actionDelete ({ record, vm, className }) {
  await vm.confirm('警告', '你确定要删除这条记录吗?')
  // 刪除此条用户数据 此用户id record.objectId
  let rs = await vm.$tkParse.delete(`/classes/${className}/${record.objectId}`).catch(() => {
    vm.$notification['error']({
      message: '网络错误',
      description: '删除数据失败'
    })
  })
  if (rs) {
    vm.$notification['success']({
      message: '操作成功',
      description: '记录已被删除'
    })
    vm.refresh()
  }
}
export {
  deleteMethods,
  actionDelete
}
